/**
 * GTM Tracking Utility
 * Centralized function for pushing affiliate click events to Google Tag Manager
 */

interface TrackAffiliateClickParams {
  provider: string;
  linkId?: string;
  deviceType?: string;
  pageType?: string;
  section?: string;
  [key: string]: any; // Allow additional custom parameters
}

export const trackAffiliateClick = (params: TrackAffiliateClickParams): void => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    console.warn('GTM dataLayer not available');
    return;
  }

  try {
    // Detect device type if not provided
    const detectedDeviceType = params.deviceType || detectDeviceType();

    window.dataLayer.push({
      event: 'affiliate_click',
      product_provider: params.provider,
      link_id: params.linkId || 'direct_link',
      device_type: detectedDeviceType,
      page_path: window.location.pathname,
      page_type: params.pageType,
      section: params.section,
      ...params // Spread any additional custom parameters
    });

    console.log('GTM affiliate_click tracked:', {
      provider: params.provider,
      linkId: params.linkId,
      deviceType: detectedDeviceType,
      pagePath: window.location.pathname
    });
  } catch (error) {
    console.error('Error tracking affiliate click:', error);
  }
};

/**
 * Detect device type based on user agent
 */
const detectDeviceType = (): string => {
  if (typeof window === 'undefined') return 'unknown';
  
  const ua = navigator.userAgent;
  
  if (/Mobile|Android|iPhone/i.test(ua)) {
    return 'mobile';
  } else if (/Tablet|iPad/i.test(ua)) {
    return 'tablet';
  }
  
  return 'desktop';
};
